import {
    Box,
    Divider,
    FormControlLabel,
    Checkbox,
    Button
} from '@mui/material';

function CouponPause() {

    return (
        <Box>
            <Box
                sx={{
                    width: '90%',
                    textAlign: 'left',
                    padding: '30px 0 10px 10px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start'
                }}>
                <img src='/img/back_button_black.png' />
                <Box
                    sx={{
                        margin: '16px 0 0 10px',
                        fontSize: '22px',
                        fontWeight: 'bold'
                    }}>
                    쿠폰 정지 신청
                </Box>
            </Box>
            <Divider />
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                <Box
                    sx={{
                        width: '80%',
                        marginTop: '20px',
                    }}>
                    <Box
                        sx={{
                            fontWeight: 'bold'
                        }}>
                        정지 쿠폰 선택
                    </Box>
                    <Box
                        sx={{
                            marginTop: '10px'
                        }}>
                        <FormControlLabel
                            sx={{
                                marginBottom: '5px'
                            }}
                            control={
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}>
                                    <Checkbox
                                        size='small'
                                    />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            fontSize: '14px'
                                        }}>
                                        <Box>
                                            클래스쿠폰 36회권
                                        </Box>
                                        {/* <Box>
                                            잔여쿠폰 : 12장
                                        </Box> */}
                                        <Box>
                                            만료일 : 2022-06-31
                                        </Box>
                                    </Box>

                                </Box>
                            }
                            label=''
                        />
                        <FormControlLabel
                            control={
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}>
                                    <Checkbox
                                        size='small'
                                    />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            fontSize: '14px'
                                        }}>
                                        <Box>
                                            클래스쿠폰 12회권
                                        </Box>
                                        {/* <Box>
                                            잔여쿠폰 : 12장
                                        </Box> */}
                                        <Box>
                                            만료일 : 2022-05-31
                                        </Box>
                                    </Box>

                                </Box>
                            }
                            label=''
                        />
                    </Box>

                    <Box
                        sx={{
                            fontWeight: 'bold',
                            marginTop: '20px',
                        }}>
                        쿠폰 정지 안내
                    </Box>
                    <Box
                        sx={{
                            fontSize: '14px'
                        }}>
                        <Box
                            sx={{
                                marginTop: '12px'
                            }}>
                            쿠폰 환불은 예약에 사용되지 않은 쿠폰에 대해 환불을 받을 수 있는 기능입니다.
                        </Box>
                        <Box
                            sx={{
                                marginTop: '12px'
                            }}>
                            남은 쿠폰 수가 잔여일보다 많은 경우, 잔여일 1일 당 쿠폰 하나로 계산합니다.
                        </Box>
                        <Box>
                            ex) 남은 쿠폰 수가 12장이고 잔여일이 8일인 경우, 환불 받을 수 있는 쿠폰 수는 8장입니다.
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box
                sx={{
                    width: '100%',
                    position: 'fixed',
                    bottom: '0',
                    background: 'white'
                }}>
                <Button variant='contained'
                    sx={{
                        width: '100%',
                        marginBottom: '20px',
                        marginTop: '10px',
                        borderRadius: '0',
                        background: '#0092a2',
                        ':hover': {
                            background: '#0092a2'
                        }
                    }}
                // onClick={onSubmit}
                >
                    쿠폰 정지 신청
                </Button>
            </Box>
        </Box>
    )
}

export default CouponPause;